export const colorPalette = {
  skeletonColor: "#696969",
  orangeColor: "#fe6c0a",
  darkGrey: "#33393f",
  blackGrey: "#18191d",
  cementGrey: "#3a3a3a",
  lightGrey: "#80868c",
};
